import { LS_KEY } from "./constants";

export function loadState() {
  try {
    const raw = localStorage?.getItem?.(LS_KEY);
    if (!raw) {
      console.warn("No saved state found in localStorage");
      return null;
    }
    const parsed = JSON.parse(raw);
    // Validate parsed data is an object
    if (typeof parsed !== 'object' || parsed === null) {
      console.warn("Corrupted state data in localStorage, resetting");
      saveState(null); // Clear corrupted data
      return null;
    }
    return parsed;
  } catch (error) {
    console.error("Error loading state from localStorage:", error);
    return null;
  }
}

export function saveState(state) {
  try {
    if (state === null || state === undefined) {
      localStorage?.removeItem?.(LS_KEY);
      return;
    }
    localStorage?.setItem?.(LS_KEY, JSON.stringify(state));
  } catch (error) {
    console.error("Error saving state to localStorage:", error);
  }
}
